// KWANKGM04040_借入申込入力（受付完了）
import React from 'react';
import HeadingM from '../../molecules/HeadingM';

interface Props {
  reception_cd: string;
  is_decline: boolean;
  is_change: boolean;
  is_change_modernization_funds?: boolean;
  guarantors_num: number; // 連帯債務者等の人数
}

const ExaminationCompleteBody: React.FC<Props> = ({
  reception_cd,
  is_decline,
  is_change,
  is_change_modernization_funds,
  guarantors_num,
}) => {
  // 見出しの文字列をセットする
  const setLabel = () => {
    if (is_decline) {
      // 辞退の場合
      return '借入申込辞退受付完了';
    } else if (is_change || is_change_modernization_funds) {
      // 変更完了の場合
      return '借入申込変更完了';
    }

    // 借入申込完了の場合
    return '借入申込完了';
  };

  // 本文のJSXをセットする
  const setBody = () => {
    if (is_decline) {
      // 辞退の場合
      return <p className="p-lead">借入申込辞退の受付を完了しました。</p>;
    } else if (is_change || is_change_modernization_funds) {
      return <p className="p-lead">借入申込の変更を完了しました。</p>;
    }

    // 借入申込完了の場合
    return (
      <p className="p-lead">
        お客様のお申し込みを受け付けました。
        <br />
        申込番号は「{reception_cd}」です。
      </p>
    );
  };

  // メール送信通知メッセージ
  const setMailSendNotice = () => {
    // 辞退、変更完了の場合は何も表示しない
    if (is_decline || is_change || is_change_modernization_funds) {
      return;
    }

    // 連帯債務者等ありの場合
    if (guarantors_num > 0) {
      return (
        <p className="p-lead">
          【メール送信】
          <br />
          ご登録のメールアドレスに借入申込受付メールを送信しました。
          <br />
          またご登録の連帯債務者等の方に申込内容確認のためのマイページ開設招待メールを送信しました。
          <br />
          連帯債務者等の方にメールが届かない場合にはマイページから本申込み案件を開き、メールの再送信を行って下さい。
        </p>
      );
    }

    // 連帯債務者等なしの場合
    return (
      <p className="p-lead">
        【メール送信】
        <br />
        ご登録のメールアドレスに借入申込受付メールを送信しました。
      </p>
    );
  };

  return (
    <>
      <HeadingM label={setLabel()} />
      {setBody()}
      {setMailSendNotice()}
    </>
  );
};

export default ExaminationCompleteBody;
